import "./contact.scss";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { LiaFaxSolid } from "react-icons/lia";
import { useState } from "react";
import GoogleMapsComponent from "../../components/maps/maps";
import { allImages } from "../../services/images";
import { Modal } from 'react-bootstrap';
import { FaCheckCircle } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

export default function ContactUs() {
  const lightMode = useAppSelector((state) => state.mode.lightMode);
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const EmailForm = () => {

    const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });

    const handleChange = (e: any) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e: any) => {
      e.preventDefault();
      const formData = new FormData();
      var valu: { [key: string]: any } = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      };
      Object.keys(valu).forEach((y) => formData.append(y, e.target[y].value));
      try {
        var respone = await fetch("https://site.pbltransport.co.in/contact.php", {
          method: 'POST',
          body: formData
        });
        console.log(respone);
        if (respone.status === 200) {
          handleShow();
          setTimeout(()=>handleClose(),3000);
        } else {
          alert("Mail sent failed please try again later");
        }
      } catch (e: any) { alert("Failed"); }
    };

    return (
      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Body className="text-center">
            <FaCheckCircle color="green" size={70} />
            <h5 className="mt-2">Your message has been sent successfully.</h5>
            <p>We will get back to you soon.</p>
          </Modal.Body>
        </Modal>

        <div className={`mail ${!lightMode ? "dark" : "white"}`}>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email<span style={{ color: "red" }}>*</span></label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Phone<span style={{ color: "red" }}>*</span></label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="message" className="form-label">Message<span style={{ color: "red" }}>*</span></label>
              <textarea
                className="form-control"
                id="message"
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div className="but"><button type="submit" className="btn btn-primary">Send Message</button></div>
          </form>
        </div>
      </>
    );
  };
  return <div className={`contactus ${lightMode ? "cbg" : "cdbg"}`}>
    <Helmet>
      <title>Contact Us - PBL Transport</title>
    </Helmet>
    <Heading lightMode={lightMode} heading="Contact Us" subclass="pc" />
    <div className="tagline">Any question or remarks? Just write us a message!</div>
    <a href="#googleMaps" style={{ color: "inherit" }}><div className="arrow desktop">
      <div>SCROLL FOR BRANCHES</div>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 17"><path d="M19,17L0.8,0.5l36.4,0L19,17z"></path></svg>
    </div></a>
    <div className={`contactBox ${lightMode ? "lightShadow" : "darkShadow"}`}>
      <div className="cards">
        <div className="bgImage">
          <img src={allImages.nclogo} alt="logo" />
        </div>
        <div className="info">
          <div className="company">PBL Transport</div>
          <div className="head">Contact Us</div>
          <div className="tagline">Reach out to our dedicated team for any inquiries, assistance, or information you need</div>
          <div className="body">
            <div className="details"><BiSolidPhoneCall size={25} /><span>+91 0891 6661277, +91 9951001277</span></div>
            <div className="details"><IoMdMail size={25} /><span>sales@pbltransport.co.in</span></div>
            <div className="details"><LiaFaxSolid size={25} /><span>0891 6661577</span></div>
            <div className="details"><FaLocationDot size={25} /><span><div>Rednam Plaza, 1st Floor</div><div>2nd Lane, Dwaraka Nagar</div><div>Visakhapatnam-530016</div><div>Andhra Pradesh</div></span></div>
          </div>
          <div className="bcircle"></div>
          <div className="scircle"></div>
        </div>
      </div>
      <EmailForm />
    </div>
    <Heading lightMode={lightMode} heading="Our Office Locations" subclass="pc" />
    <GoogleMapsComponent />
  </div>
}